const contractStatus = {
	ACTIVE: "Aktiv",
	ORDER: "Bestellung",
	OFFER: "Angebot",
	INACTIVE: "Inaktiv"
}

export default contractStatus;

